import RibbonPlugin from 'owa-editor-ribbonplugin/lib/plugin/RibbonPlugin';
import { getUserConfiguration } from 'owa-session-store';
import * as React from 'react';
import { ReactEditor } from 'owa-editor';
import { Ribbon } from 'owa-editor-ribbonplugin';
import { EditorPlugin } from 'roosterjs-editor-core';
import { observer } from 'mobx-react';
import EditorViewState from 'owa-editor/lib/store/schema/EditorViewState';
import RibbonViewState from 'owa-editor-ribbonplugin/lib/store/schema/RibbonViewState';

const styles = require('./OptionsEditor.scss');

export interface ExternalMessageEditorProps {
    ribbonViewState: RibbonViewState;
    editorViewState: EditorViewState;
    watermark?: string;
    isRtl?: boolean;
    initialize?: () => void;
}

@observer
export default class OptionsEditor extends React.Component<ExternalMessageEditorProps, {}> {
    private ribbonPlugin: RibbonPlugin;

    constructor(props: ExternalMessageEditorProps) {
        super(props);
        this.ribbonPlugin = new RibbonPlugin(() => this.props.ribbonViewState);
    }

    componentDidMount() {
        if (this.props.initialize) {
            this.props.initialize();
        }
    }

    render() {
        let isRtl =
            this.props.isRtl || getUserConfiguration().SessionSettings.IsUserCultureRightToLeft;

        let watermark = this.props.watermark || '';

        return (
            <div className={styles.editorContainer}>
                <Ribbon
                    key="ribbon"
                    ribbonPlugin={this.ribbonPlugin}
                    viewState={this.props.ribbonViewState}
                    className={styles.ribbon}
                    isRtl={isRtl}
                />
                <ReactEditor
                    key="editor"
                    watermark={watermark}
                    isRtl={isRtl}
                    viewState={this.props.editorViewState}
                    plugins={this.plugins}
                    classNames={styles.editor}
                    updateOnKeyPress={true}
                />
            </div>
        );
    }

    private get plugins(): EditorPlugin[] {
        // VSO 14829 - Use a common collection of plugins
        return [this.ribbonPlugin];
    }
}
